import { render, staticRenderFns } from "./ProcessContatti.vue?vue&type=template&id=6356af28&"
import script from "./ProcessContatti.vue?vue&type=script&lang=js&"
export * from "./ProcessContatti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports